import { InjectionToken } from "@angular/core";

export const CONTROL = new InjectionToken<string>('control', {
  providedIn: 'root',
  factory: () => 'control',
}); 
export const BODY_CONTROL = new InjectionToken<string>('sectionFormControl', {
  providedIn: 'root',
  factory: () => 'sectionFormControl',
}); 

